function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createVNode as _createVNode } from "vue";
import { computed, defineComponent, ref } from "vue";
import { addUnit, truthProp, numericProp, preventDefault, makeStringProp, makeNumberProp, makeNumericProp, createNamespace } from "../utils";
import { useRect, useCustomFieldValue } from "@vant/use";
import { useRefs } from "../composables/use-refs";
import { useTouch } from "../composables/use-touch";
import { Icon } from "../icon";

var _createNamespace = createNamespace("rate"),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

function getRateStatus(value, index, allowHalf, readonly) {
  if (value >= index) {
    return {
      status: "full",
      value: 1
    };
  }

  if (value + 0.5 >= index && allowHalf && !readonly) {
    return {
      status: "half",
      value: 0.5
    };
  }

  if (value + 1 >= index && allowHalf && readonly) {
    var cardinal = Math.pow(10, 10);
    return {
      status: "half",
      value: Math.round((value - index + 1) * cardinal) / cardinal
    };
  }

  return {
    status: "void",
    value: 0
  };
}

var rateProps = {
  size: numericProp,
  icon: makeStringProp("star"),
  color: String,
  count: makeNumericProp(5),
  gutter: numericProp,
  readonly: Boolean,
  disabled: Boolean,
  voidIcon: makeStringProp("star-o"),
  allowHalf: Boolean,
  voidColor: String,
  touchable: truthProp,
  iconPrefix: String,
  modelValue: makeNumberProp(0),
  disabledColor: String
};
var stdin_default = defineComponent({
  name: name,
  props: rateProps,
  emits: ["change", "update:modelValue"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var touch = useTouch();

    var _useRefs = useRefs(),
        _useRefs2 = _slicedToArray(_useRefs, 2),
        itemRefs = _useRefs2[0],
        setItemRefs = _useRefs2[1];

    var groupRef = ref();

    var untouchable = function untouchable() {
      return props.readonly || props.disabled || !props.touchable;
    };

    var list = computed(function () {
      return Array(+props.count).fill("").map(function (_, i) {
        return getRateStatus(props.modelValue, i + 1, props.allowHalf, props.readonly);
      });
    });
    var ranges;
    var groupRefRect;
    var minRectTop = Number.MAX_SAFE_INTEGER;
    var maxRectTop = Number.MIN_SAFE_INTEGER;

    var updateRanges = function updateRanges() {
      groupRefRect = useRect(groupRef);
      var rects = itemRefs.value.map(useRect);
      ranges = [];
      rects.forEach(function (rect, index) {
        minRectTop = Math.min(rect.top, minRectTop);
        maxRectTop = Math.max(rect.top, maxRectTop);

        if (props.allowHalf) {
          ranges.push({
            score: index + 0.5,
            left: rect.left,
            top: rect.top,
            height: rect.height
          }, {
            score: index + 1,
            left: rect.left + rect.width / 2,
            top: rect.top,
            height: rect.height
          });
        } else {
          ranges.push({
            score: index + 1,
            left: rect.left,
            top: rect.top,
            height: rect.height
          });
        }
      });
    };

    var getScoreByPosition = function getScoreByPosition(x, y) {
      for (var i = ranges.length - 1; i > 0; i--) {
        if (y >= groupRefRect.top && y <= groupRefRect.bottom) {
          if (x > ranges[i].left && y >= ranges[i].top && y <= ranges[i].top + ranges[i].height) {
            return ranges[i].score;
          }
        } else {
          var curTop = y < groupRefRect.top ? minRectTop : maxRectTop;

          if (x > ranges[i].left && ranges[i].top === curTop) {
            return ranges[i].score;
          }
        }
      }

      return props.allowHalf ? 0.5 : 1;
    };

    var select = function select(index) {
      if (!props.disabled && !props.readonly && index !== props.modelValue) {
        emit("update:modelValue", index);
        emit("change", index);
      }
    };

    var onTouchStart = function onTouchStart(event) {
      if (untouchable()) {
        return;
      }

      touch.start(event);
      updateRanges();
    };

    var onTouchMove = function onTouchMove(event) {
      if (untouchable()) {
        return;
      }

      touch.move(event);

      if (touch.isHorizontal()) {
        var _event$touches$ = event.touches[0],
            clientX = _event$touches$.clientX,
            clientY = _event$touches$.clientY;
        preventDefault(event);
        select(getScoreByPosition(clientX, clientY));
      }
    };

    var renderStar = function renderStar(item, index) {
      var icon = props.icon,
          size = props.size,
          color = props.color,
          count = props.count,
          gutter = props.gutter,
          voidIcon = props.voidIcon,
          disabled = props.disabled,
          voidColor = props.voidColor,
          allowHalf = props.allowHalf,
          iconPrefix = props.iconPrefix,
          disabledColor = props.disabledColor;
      var score = index + 1;
      var isFull = item.status === "full";
      var isVoid = item.status === "void";
      var renderHalf = allowHalf && item.value > 0 && item.value < 1;
      var style;

      if (gutter && score !== +count) {
        style = {
          paddingRight: addUnit(gutter)
        };
      }

      var onClickItem = function onClickItem(event) {
        updateRanges();
        select(allowHalf ? getScoreByPosition(event.clientX, event.clientY) : score);
      };

      return _createVNode("div", {
        "key": index,
        "ref": setItemRefs(index),
        "role": "radio",
        "style": style,
        "class": bem("item"),
        "tabindex": disabled ? void 0 : 0,
        "aria-setsize": count,
        "aria-posinset": score,
        "aria-checked": !isVoid,
        "onClick": onClickItem
      }, [_createVNode(Icon, {
        "size": size,
        "name": isFull ? icon : voidIcon,
        "class": bem("icon", {
          disabled: disabled,
          full: isFull
        }),
        "color": disabled ? disabledColor : isFull ? color : voidColor,
        "classPrefix": iconPrefix
      }, null), renderHalf && _createVNode(Icon, {
        "size": size,
        "style": {
          width: item.value + "em"
        },
        "name": isVoid ? voidIcon : icon,
        "class": bem("icon", ["half", {
          disabled: disabled,
          full: !isVoid
        }]),
        "color": disabled ? disabledColor : isVoid ? voidColor : color,
        "classPrefix": iconPrefix
      }, null)]);
    };

    useCustomFieldValue(function () {
      return props.modelValue;
    });
    return function () {
      return _createVNode("div", {
        "ref": groupRef,
        "role": "radiogroup",
        "class": bem({
          readonly: props.readonly,
          disabled: props.disabled
        }),
        "tabindex": props.disabled ? void 0 : 0,
        "aria-disabled": props.disabled,
        "aria-readonly": props.readonly,
        "onTouchstart": onTouchStart,
        "onTouchmove": onTouchMove
      }, [list.value.map(renderStar)]);
    };
  }
});
export { stdin_default as default };